import ApplicationLogo from '@/Components/ApplicationLogo.jsx';
import InertiaLink from '@/Components/Common/InertiaLink.jsx';
import {Head} from '@inertiajs/react';
import {Box, Button, styled, Typography} from '@mui/material';
import * as React from 'react';

const WelcomeImage = (props) => <img {...props} src={'/images/home.avif'} alt="" />;
const StyledWelcomeImage = styled(WelcomeImage)(({theme}) => ({
    [theme.breakpoints.up('md')]: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        objectPosition: 'center',
        aspectRatio: '1 / 1',
    },
}));

export default function Welcome() {
    return (
        <>
            <Head title="Outils de sélection de Pompes à chaleur MITSUBISHI ELECTRIC" />
            <Box sx={boxStyle}>
                <Box sx={imageContainerStyle}>
                    <StyledWelcomeImage />
                </Box>
                <Box sx={textContainerStyle}>
                    <ApplicationLogo
                        style={{
                            objectFit: 'contain',
                            height: 56,
                            width: 162,
                        }}
                    />
                    <Typography variant="h1">Outil de sélection de Pompes à chaleur MITSUBISHI ELECTRIC</Typography>
                    <Typography component="p" variant="subtitle1" sx={paragraphStyle}>
                        Select ME est un logiciel de sélection de Pompe à chaleur…
                        <br />
                        Cet outil de travail analyse et sélectionne pour l’utilisateur les produits répondant à ses
                        besoins, génère des rapports personnalisés, et centralise dans un espace dédié son carnet
                        d’adresses ainsi que ses projets réalisés
                    </Typography>
                    <Box sx={buttonsContainerStyle}>
                        <Button
                            key={'page-welcome-login'}
                            variant="contained"
                            color="primary"
                            component={InertiaLink}
                            href={route('login')}
                            sx={buttonsStyle}
                        >
                            Accès
                        </Button>
                        <Button
                            key={'page-welcome-about'}
                            variant="soft"
                            color="neutral"
                            href="#about"
                            sx={buttonsStyle}
                        >
                            En savoir plus
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
}

const boxStyle = (theme) => ({
    display: {xs: 'block', md: 'flex'},
    flex: '1 0 auto',
    gap: {xs: 2.5, md: 5},
    p: {md: [0, 4]},
    m: 'auto',
    width: '100%',
    minHeight: '1px',
    maxWidth: theme.breakpoints.values.xl,
});

const imageContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: {xs: 'stretch', md: 'flex-end'},
    height: {xs: 'auto', md: '100%'},
    maxHeight: {xs: '50vh', md: 'none'},
    minHeight: {xs: 'none', md: '400px'},
    width: {xs: '100%', md: '50%'},
    maxWidth: {xs: 'none', md: '600px'},
    flex: {xs: '1 1 auto', md: '0 0 auto'},
    overflow: 'hidden',
};

const textContainerStyle = (theme) => ({
    display: 'flex',
    flexFlow: 'column nowrap',
    flexWrap: 'wrap',
    flex: '1 1 auto',
    gap: 2.5,
    m: 'auto 0',
    width: {xs: 'auto', md: '50%'},
    minWidth: '1px',
    p: 4,
    textAlign: {xs: 'center', md: 'left'},

    [theme.breakpoints.down('md')]: {
        alignItems: 'center',
    },
});

const paragraphStyle = (theme) => ({
    fontWeight: 400,
    lineHeight: '1.5',
    textWrap: 'pretty',
    color: theme.palette.neutral['500'],
});

const buttonsContainerStyle = (theme) => ({
    display: 'flex',
    gap: 1,

    [theme.breakpoints.down('lg')]: {
        justifyContent: 'center',
    },
});

const buttonsStyle = (theme) => ({
    fontWeight: 700,
});
